import { render, staticRenderFns } from "./Tipomacchina.vue?vue&type=template&id=97cb4786&"
import script from "./Tipomacchina.vue?vue&type=script&lang=js&"
export * from "./Tipomacchina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports